export default __webpack_public_path__ + "static/thumb-landscape-6ab2a2a74fa5a901747ab799a95b6b23.jpg";